import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Card, CardContent } from '../../../components/ui/card';
import { projectStatusHelper } from '../helpers/reportHelpers';
import ProjectStatusChart from './ProjectStatusChart';
import { fetchProjectInformation } from '../api/projectInformation';

interface ProjectStatusProps {
  projectStatusPipeData: any[];
  isLoading: boolean;
  projectNumber: string;
}

export const ProjectStatus: React.FC<ProjectStatusProps> = ({
  projectStatusPipeData,
  isLoading,
  projectNumber,
}) => {
  const pipeCounts = useSelector((state: any) => state.pipefitterProject || {});
  const chartData = projectStatusHelper(projectStatusPipeData || [], pipeCounts);
  const [targetPipeEnds, setTargetPipeEnds] = useState<number | null>(null);

  useEffect(() => {
    let cancelled = false;
    const trimmedProjectNumber = projectNumber.trim();
    if (!trimmedProjectNumber) {
      setTargetPipeEnds(null);
      return;
    }

    fetchProjectInformation(trimmedProjectNumber)
      .then((projectInfo) => {
        if (cancelled) return;
        const value = Number(projectInfo?.targetNumberOfPipesEnds);
        setTargetPipeEnds(Number.isFinite(value) && value >= 0 ? value : null);
      })
      .catch(() => {
        if (!cancelled) setTargetPipeEnds(null);
      });

    return () => {
      cancelled = true;
    };
  }, [projectNumber]);

  return (
    <Card>
      <CardContent className="p-6">
        <div className="space-y-4">
          {projectStatusPipeData && projectStatusPipeData.length > 0 ? (
            <ProjectStatusChart chartData={chartData} targetPipeEnds={targetPipeEnds} />
          ) : (
            <div className="text-center py-8 text-gray-500">No data available.</div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
